import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import { VMuserService} from '../profile.service';
import { VMuser, VMuserForm } from '../model/model.class';
import { Router } from '@angular/router';
import { MatSelect, MatSnackBar } from '@angular/material';
import { AppComponentClass } from '../../shared/service/AppComponent.class';

@Component({
  selector: 'app-vmaccount',
  templateUrl: './vmaccount.component.html',
  styleUrls: ['./vmaccount.component.css']
})

export class VmaccountComponent extends AppComponentClass <VMuser, VMuserForm> {

  form : FormGroup; 
  stateone:boolean=false;
  isverified:boolean=false;
  iswait:boolean=false;
  public vmid:number;

  constructor(protected data: VMuserService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar) {
    super(data, router, fb , msg); 
  }

  ngOnInit() {
    this.data.getService().subscribe(res =>{
      if(res != null)
      {
        this.cdata=new VMuserForm(res[0]);
        this.keyfield = res[0].id;
        this.form=this.cdata.makeform(this.fb);
        this.isverified = true;
        this.vmid = res[0].vm_iduser;
      }
      else
      {
        this.cdata=new VMuserForm(null);
        this.form=this.cdata.makeform(this.fb);
        this.isverified=false;
      }
      this.stateone=true;
    },
    err =>{
      this.cdata=new VMuserForm(null);
      this.form=this.cdata.makeform(this.fb);
      this.stateone=true;
      this.isverified = false;
    });
    
  }

  OnChangeKey(event:any, key:number)
  {
    switch(key)
    {
      case 1 :
      {
        if(event.checked==true)
          this.cdata.lead=1;
        else
          this.cdata.lead=0;
      }
      break;
      case 2 :
      {
        if(event.checked==true)
          this.cdata.cdr=1;
        else
          this.cdata.cdr=0;
      }
      break;
      case 3 :
      {
        if(event.checked==true)
          this.cdata.disposition=1;
        else
          this.cdata.disposition=0;
      }
      break;
      case 4 :
      {
        if(event.checked==true)
          this.cdata.voicemail=1;
        else
          this.cdata.voicemail=0;
      }
      break;
      case 5 :
      {
        if(event.checked==true)
          this.cdata.sms=1;
        else
          this.cdata.sms=0;
      }
      break;
      case 6 :
      {
        if(event.checked==true)
          this.cdata.email=1;
        else
          this.cdata.email=0;
      }
      break;
      case 7 :
      {
        if(event.checked==true)
          this.cdata.objection=1;
        else
          this.cdata.objection=0;
      }
      break;
      case 7 :
      {
        if(event.checked==true)
          this.cdata.didcredit=1;
        else
          this.cdata.didcredit=0;
      }
      break;
    }
  }

  onSubmit()
  {
    console.log("Thanks for submitt");
    if(this.cdata.saveForm(this.form))    
    {
      this.iswait = true;
      console.log(this.cdata);
      this.data.VerifyAccount(JSON.stringify(this.cdata)).subscribe(res =>{
        console.log(res);
        this.iswait = false;
        if(res.id)
        {
          this.isverified = true;
          this.openSnackBar("Account Verification Process Completed Successfully", "Clear");
        }          
        else
        {
          this.isverified = false;
          this.openSnackBar("Account Verification Failed. Please Enter Valid Credentials", "Clear");
        }          
      },
      err =>{
        this.iswait = false;
        this.openSnackBar("Account Verification Failed. Please Enter Valid Credentials", "Clear");
      }); 
    }
  }

  Onsetting()
  {
    console.log("Thanks for submitt");
    if(this.cdata.saveForm(this.form))    
    {
      console.log(this.cdata);
      this.data.updateService(JSON.stringify(this.cdata), this.keyfield, "vmsetting").subscribe(res =>{
        this.openSnackBar("Data Updated Successfully", "Clear");
      }); 
    }
  }

  SyncCallerID()
  {
    console.log(this.vmid);
    this.data.SyncCallerIDCredit(this.vmid.toString()).subscribe(res =>{
      let ddcredit = parseInt(sessionStorage.getItem("did_credit")) + parseInt(res.did_credit);
      sessionStorage.setItem("did_credit", ddcredit.toString());
      this.openSnackBar("CallerID credit synced successfully.", "Clear");
      location.reload(true)
    },
    err =>{
      this.openSnackBar("CallerID credit syncing failed.", "Clear");
    });
  }

  SyncMinute()
  {
    console.log(this.vmid);    
    this.data.Syncminutes(this.vmid.toString()).subscribe(res =>{
      sessionStorage.setItem("minutes", parseInt(sessionStorage.getItem("minutes")) + res.minute);
      this.openSnackBar("Minute synced successfully.", "Clear");
      location.reload(true)
    },
    err =>{
      this.openSnackBar("Minutes syncing failed.", "Clear");
    });
  }

}
